import React from "react";

class NhRankingSearchSuggestion extends React.Component {
  handleClick = (location) => {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(location);
    }
  };

  getLocations = () => {
    const { ispage } = this.props;
    const suffix = ispage === "nhranking" ? "-CA" : "";

    return [
      { cityName: "San Francisco", cityUrl: `San-Francisco${suffix}` },
      { cityName: "Peninsula", cityUrl: `Peninsula${suffix}` },
      { cityName: "Silicon Valley", cityUrl: `Silicon-Valley${suffix}` },
      { cityName: "East Bay", cityUrl: `East-Bay${suffix}` },
      { cityName: "Marin", cityUrl: `Marin${suffix}` },
    ];
  };

  render() {
    const locations = this.getLocations();

    return (
      <div className="location-list">
        {locations.map((city, index) => (
          <span
            key={city.cityUrl}
            className="location-item"
            onClick={() => this.handleClick(city)}
          >
            {city.cityName}
          </span>
        ))}
      </div>
    );
  }
}

export default NhRankingSearchSuggestion;
